import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { genSpecificDateTime } from '../../util/dateTime';
import { priceFormat } from '../../util/showPriceFormat';
import config from './../../config.json';
import './SuccessOrder.css'

const SuccessfullOrder = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        if (!state) {
            return navigate('/', { replace: true })
        }
    }, [navigate, state])

    return (
        state &&
        <div className="successPage">
            <header className="header-successPage">
                <div className="background-layer-successPage"></div>
            </header>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-sm-10 col-md-9 col-lg-7 col-xl-6 ">
                        <div className="success-icon text-center mt-2">
                            <i className="fa fa-check-circle text-success fs-1"></i>
                        </div>
                        <div className="text-center mt-3 mb-4">
                            <h5 className="text-success">سفارش شما با موفقیت ثبت شد</h5>
                        </div>
                        <div className="d-flex flex-wrap justify-content-between background-success-facture success-order-layer">
                            <div className="col-6 font-weight-bold mt-2">شماره فاکتور : </div>
                            <div className="col-6 text-end">{state.factureNumber}</div>
                            <div className="col-6 font-weight-bold mt-2">مبلغ پرداختی : </div>
                            <div className="col-6 text-end">{priceFormat(String(state.totalPrice))} {config.currencyType}</div>
                            <div className="col-5 font-weight-bold mt-2">تاریخ ثبت : </div>
                            <small className="col-7 text-end" style={{ direction: 'ltr' }}>{genSpecificDateTime(state.createdAt).dateTimeStr}</small>
                        </div>
                        <div className='col-12 text-center mt-3'>
                            <button className='btn btn-success'
                                onClick={() => navigate('/userOrders')}
                            >مشاهده همه سفارشات</button>
                        </div>
                        <div className="text-center my-3" style={{ fontSize: '.9rem' }}>
                            <p className="text-dark">
                                برای تایید نهایی سفارش همکاران ما
                                به زودی با شما تماس خواهند گرفت . اگه نیاز به دریافت فوری
                                سفارش خود رادارید ، با شماره
                                <span className="font-weight-bold mx-1">09192770652</span>
                                تماس بگیرید
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}



export default SuccessfullOrder;